import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = { children: ReactNode }

type State = { error: Error | null }

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[SPA]', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-surface p-6 flex flex-col items-center justify-center gap-3 text-center">
          <p className="text-headline-md text-primary font-bold">Terjadi kesalahan</p>
          <p className="text-body-sm text-on-surface-variant max-w-md">{this.state.error.message}</p>
          <button
            type="button"
            className="btn-primary mt-2"
            onClick={() => window.location.assign('/')}
          >
            Muat ulang
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
